import { jobCreators } from '../behavior/jobCreators-sidecar'
import { jobs } from '../behavior/jobs-sidecar'
import { IBlueprint } from './blueprints'
import { blueprints } from './blueprints-sidecar'

function ensure(obj: IBlueprint) {
  blueprints.ensureType(obj, 'deconstruct-hull')
}

export function onCreate(obj: IBlueprint) {
  ensure(obj)
  obj.onUpdate = onUpdate

  let jc = jobCreators.create(
    () => {
      return true
    },
    () => {
      let j = jobs.create('deconstruct-hull')
      j.blueprint = obj
      return j
    },
  )
  obj.jobCreators.push(jc)
}

export function onUpdate(obj: IBlueprint) {
  ensure(obj)
}
